import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  const $reset = $('[data-reset]')
  debugLogScriptName($reset, 'reset-form.js') // DEBUG
  $reset.on('click', function(e) {
    var $form = $($(this).attr('data-reset'))

    $(this)
      .text('Please wait')
      .prop('disabled', true)
    $form.find('input[type="checkbox"]').prop('checked', false)
    $form
      .find('input, select')
      .val('')
      .change()
    Object.values($form.find('select')).forEach(element => {
      if (element.selectize && element.selectize.setValue) {
        element.selectize.setValue('')
      }
    })

    $form.trigger('reset')
  })
})
